<template>
<div class="mb-5">
<ForgetPassword/>

</div>
  


</template>

<script>
import ForgetPassword from "../components/ForgetPassword.vue";
  export default {
    data(){
      return {
      }
    },
    beforeCreate: function() {
        document.body.className = 'home';
    },
    components: {
   ForgetPassword
    },
    methods:{
      
    }
    
    
    
    
  };
</script>

<style scoped>
  label {
    display: block;
    margin-top: 10px;
  }

  .card-container.card {
    max-width: 350px !important;
    padding: 40px 40px;
  }

  .card {
    background-color: #f7f7f7;
    padding: 20px 25px 30px;
    margin: 0 auto 25px;
    margin-top: 50px;
    -moz-border-radius: 2px;
    -webkit-border-radius: 2px;
    border-radius: 2px;
    -moz-box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.3);
    -webkit-box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.3);
    box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.3);
  }

  .profile-img-card {
    width: 96px;
    height: 96px;
    margin: 0 auto 10px;
    display: block;
    -moz-border-radius: 50%;
    -webkit-border-radius: 50%;
    border-radius: 50%;
  }

  .panal {
    background: #0000009e;
    border-radius: 10px 10px 0px 0px;
    color: #fff;
    padding: 0px 0px 50px 0px;

  }

  .panal-header {
    background: #FFFFFF;
    color: #285475;
    text-align: center;
    border-radius: 10px 10px 0px 0px;
    padding: 15px;
    font-size: 30px;
    font-weight: bold;
    -moz-box-shadow: inset 0 0 5px #000000;
    -webkit-box-shadow: inset 0 0 5px #000000;
    box-shadow:
  }

  .mt-20 {
    margin-top: 20px;
  }

  .mt-40 {
    margin-top: 40px;
  }

  .form-control {

    color: #ffffff;
    background-color: #9191916b !important;
    background-clip: padding-box;
    border: 1px solid #ced4da75 !important;
  }

  .btn-outline-secondary {
    color: #ffffff;
    border-color: #ffffff;
  }

  .divider {
    font-size: 20px;
    margin: -0.65em auto -0.45em;
    overflow: hidden;
    text-align: center;
    line-height: 1.2em;
  }

  .divider:before,
  .divider:after {
    content: "";
    vertical-align: top;
    display: inline-block;
    width: 50%;
    height: 0.65em;
    border-bottom: 1px solid #fff;
    margin: 0 2% 0 -55%;
  }

  .divider:after {
    margin: 0 -55% 0 2%;
  }


  ::placeholder {
    color: #fff !important;
    opacity: 1;
    /* Firefox */
  }

  :-ms-input-placeholder {
    /* Internet Explorer 10-11 */
    color: #fff !important;
  }

  ::-ms-input-placeholder {
    /* Microsoft Edge */
    color: #fff !important;
  }

  .form-control:focus {
    color: #ffffff !important;
  }
  
  @import url('../assets/style.css');

</style>